import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { Link } from 'react-router-dom';
import React, { ReactNode } from 'react';
import CaseEnum from '../../../../../../../../../enumerables/case-enum';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

export const GroupPayroll = (data: { type?: string; list?: any }): { [key: string]: string | ReactNode }[] => {
    const showDataList: { [key: string]: string | ReactNode }[] = [];
    const varsType: AnyObject = {
        payroll_admin_works: 'Admin Work',
        payroll_expenses: 'Expenses',
        payroll_internals: 'Internal Payment',
        payroll_advances: 'Advance',
        payroll_deductions: 'Deductions',
        payroll_payments: 'Payments',
    };

    const TypeValue: any = varsType[`${data?.type}`];

    data.list.forEach((itList: any) => {
        const caseType = itList.seance?.occasion?.caseType;
        const orderTypes = CaseEnum ? CaseEnum.getEnum(`OrderType_${caseType}`) : {};
        const orderTypesValues: SelectObject[] = getValFromEnum(orderTypes);

        let valueOrderType: any = orderTypesValues.find((it) => +it.value === +`${itList.seance?.occasion?.orderType}`);

        valueOrderType = valueOrderType ? valueOrderType.label : '';
        let clientName = '';
        let clientLink: ReactNode = '';
        if (itList.seance?.student) {
            clientName = itList.seance?.student?.firstName
                ? `Student: ${itList.seance?.student?.firstName} ${itList.seance.student.lastName}`
                : '';
            clientLink = (
                <Link
                    to={Router.generate(routes.STUDENT_DETAIL, { id: itList.seance?.student?.id, tab: 'student-info' })}
                >
                    {clientName}
                </Link>
            );
        } else if (itList.seance?.district) {
            clientName = itList.seance?.district?.name ? `District: ${itList.seance?.district?.name}` : '';
            clientLink = (
                <Link to={Router.generate(routes.DISTRICT_DETAIL, { id: itList.seance?.district?.id })}>
                    {clientName}
                </Link>
            );
        } else {
            clientName = itList.seance?.vendor?.name ? `Vendor: ${itList.seance?.vendor?.name}` : '';
            clientLink = (
                <Link to={Router.generate(routes.VENDOR_DETAIL, { id: itList.seance?.vendor?.id })}>{clientName}</Link>
            );
        }
        let totalPayable = itList.amount;
        if (data?.type === 'payroll_payments') {
            totalPayable = itList.totalPayable ? `${itList.totalPayable}` : '0';
        }

        const valDate = itList.seanceDate
            ? itList.seanceDate
            : itList.internalDate
            ? itList.internalDate
            : itList.adminWorkDate
            ? itList.adminWorkDate
            : itList.expenseDate
            ? itList.expenseDate
            : '';
        const valStartTime = itList.seanceStartTime
            ? itList.seanceStartTime
            : itList?.adminWork?.startTime
            ? itList?.adminWork?.startTime
            : '';
        const valEndTime = itList.seanceEndTime
            ? itList.seanceEndTime
            : itList?.adminWork?.endTime
            ? itList?.adminWork?.endTime
            : '';

        const showData: { [key: string]: string | ReactNode } = {
            caseNumber: itList.seance?.occasion?.caseNumber ? itList.seance.occasion.caseNumber : '', //
            clientLink: clientLink, //
            client: clientName, //
            serviceType: itList.seance?.serviceType?.title ? itList.seance.serviceType.title : '', //
            serviceLocation: itList.seance?.serviceLocation?.title ? itList.seance.serviceLocation.title : '', //
            orderType: valueOrderType, //
            sessionDate: valDate ? `${changeToZeroMoment(valDate, 'MMM D, YYYY')}` : '', //
            startTime: valStartTime ? changeToZeroMoment(valStartTime, 'LT') : '', //
            endTime: valEndTime ? changeToZeroMoment(valEndTime, 'LT') : '', //
            totalUnits: itList.totalUnit ? `${itList.totalUnit}` : '0', //
            minPerUnit: itList.minPerUnit ? `${itList.minPerUnit}` : '0', //
            totalHours: itList.totalHours ? `${itList.totalHours}` : '0', //
            type: TypeValue, //
            colorColumn: data?.type, //
            externalRatePerHour: itList.externalRatePerHour ? `$${numberWithCommas(itList.externalRatePerHour)}` : '$0', //
            internalRatePerHour: itList.internalRatePerHour ? `$${numberWithCommas(itList.internalRatePerHour)}` : '$0', //
            total: itList.amount ? `${itList.amount}` : '0', //
            coveredByInvoicePaymentPer: itList.coveredByInvoicePercent ? `${itList.coveredByInvoicePercent}` : '0',
            coveredByInvoicePaymentAmount: itList.coveredByInvoice ? `${itList.coveredByInvoice}` : 0,
            leftToPay: itList.leftToPay ? `${itList.leftToPay}$` : `$0`, //
            advancePaid: itList.advancePaid ? `${itList.advancePaid}` : 0, //
            totalPayable: totalPayable, // ?
        };

        showDataList.push(showData);
    });

    return showDataList;
};
